import onGoingPresentationIcon from "assets/svg/greyPresentationIcon.svg";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CButton } from "../Button/Buttons";
import eyeWhite from "assets/svg/eyeWhite.svg";
import closeSquare from "assets/svg/closeSquare.svg";
import { SideDrawer } from "../Drawers/SideDrawer";
import instance from "../../../lib/axiosInterceptor";
import { ClipLoader } from "react-spinners";
import {
  EventsInterface,
  PresentationDataInterface,
} from "../../../interfaces/interfaces-data";
import closeIcon from "assets/svg/close-circle-dark-gray.svg";
import {
  setOnGoingEvent,
  setOnGoingPresentation,
} from "../../../store/OnGoing/onGoingAction";
import { getTeamsState } from "../../../store/Teams/teamsSlice";
import { pickByEnv } from "utils/environment";

export const OnGoingAction = ({
  type,
  url,
}: {
  type: "Event" | "Presentation";
  url: string;
}) => {
  const { teamInfo } = useSelector(getTeamsState);
  const navigate = useNavigate();
  const [showAction, setShowAction] = useState(true);
  const [sideDrawerOpen, setSideDrawerOpen] = useState(false);
  const [presentationLoading, setPresentationLoading] = useState(true);
  const [onGoingPresentations, setOnGoingPresentations] = useState<
    PresentationDataInterface[]
  >([]);
  const [onGoingEvents, setOnGoingEvents] = useState<EventsInterface[]>([]);
  const dispatch = useDispatch();

  const { onGoingPresentation } = useSelector(
    (state: any) => state.onGoingActionSlice
  );

  const getEvents = async (teamId: string) => {
    try {
      setPresentationLoading(true);
      const result = await instance.get(`/Events?teamId=${teamId}`);
      const allEvents: EventsInterface[] = result.data.data.events;
      const onGoingEvents = allEvents.filter(
        (item) => item.status === 1 && item.role === "EventOwner"
      );
      if (!onGoingEvents.length) {
        setSideDrawerOpen(false);
        dispatch(
          setOnGoingEvent({
            isEvent: false,
            id: "",
            active: false,
            teamId: teamInfo?.data?.id,
          })
        );
        return;
      }
      setOnGoingEvents(onGoingEvents);
    } catch (e) {
    } finally {
      setPresentationLoading(false);
    }
  };
  const getPresentations = async () => {
    // const
    try {
      const result = await instance.get("/presentation/all");
      // Now resolve presentations that are onGoing
      const allPresentations: PresentationDataInterface[] = result.data;
      const onGoingPresentations = allPresentations.filter(
        (item) => item.status === 2
      );
      if (!onGoingPresentations.length) {
        setSideDrawerOpen(false);
        dispatch(
          setOnGoingPresentation({
            active: false,
            id: "",
            isEvent: false,
            eventId: "",
          })
        );
      }
      setOnGoingPresentations(onGoingPresentations);
    } catch (e) {
    } finally {
      setPresentationLoading(false);
    }
  };
  useEffect(() => {
    // getPresentations();
    const teamId = teamInfo?.data?.id;
    if (teamId) {
      getEvents(teamId);
    }
  }, [teamInfo]);
  return (
    <div>
      <SideDrawer
        onClose={() => setSideDrawerOpen((prev) => !prev)}
        open={sideDrawerOpen}
        title={pickByEnv({
          live: "Ongoing Presentations",
          development: "Ongoing Events",
        })}
        showNumber={true}
        numericVal={onGoingEvents.length}
      >
        <div className={"border-t mt-3 pt-3"}>
          {presentationLoading ? (
            <div className="flex items-center justify-center h-full">
              <ClipLoader color={"#AFAFAF"} size={16} />
            </div>
          ) : (
            onGoingEvents.map((item) => {
              return (
                <OnGoingEventWrapper
                  teamId={teamInfo?.data?.id}
                  getEvents={() => {
                    getEvents(teamInfo?.data?.id);
                  }}
                  event={item}
                />
              );
            })
          )}
        </div>
      </SideDrawer>
      {showAction && (
        <div
          // onClick={() => navigate(url)}
          className={`cursor-pointer ${
            type === "Event" && onGoingPresentation ? "top-16" : "top-0"
          }  fixed top-0 z-50 p-3  w-full min-h-[80px]`}
        >
          <div className="flex px-4 gap-2 bg-[#333333] opacity-90 w-full justify-between items-center p-2 rounded-lg">
            <div className="flex items-center gap-4">
              <div>
                <img src={onGoingPresentationIcon} alt={""} />
              </div>
              <div>
                <p className="text-white text-lg">
                  On going{" "}
                  {type === "Event"
                    ? pickByEnv({ live: "presentation", development: "event" })
                    : "presentation"}
                </p>
                <p className="text-white text-xs">
                  You have{" "}
                  {type === "Event"
                    ? pickByEnv({
                        live: "a presentation",
                        development: "an event",
                      })
                    : "a presentation"}{" "}
                  going on , click the banner to return to
                  {type === "Event"
                    ? pickByEnv({
                        live: " presentation",
                        development: " event",
                      })
                    : " presentation"}
                </p>
              </div>
            </div>
            <div className={"flex items-center gap-2 "}>
              {/*<img src={rightBannerIcon} alt={""}/>*/}
              <CButton
                action={() => setSideDrawerOpen(true)}
                variant={"transparentPlain"}
                text={"View all"}
                icon={eyeWhite}
                iconPosition={"left"}
              />
              <span
                onClick={() => {
                  setShowAction(false);
                }}
              >
                <img src={closeSquare} alt={""} />
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const OnGoingEventWrapper = ({
  event,
  getEvents,
  teamId,
}: {
  event: EventsInterface;
  getEvents: () => void;
  teamId: string;
}) => {
  const [checking, setChecking] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const endOnGoingEvent = async () => {
    try {
      setLoading(true);
      const result = await instance.post(
        `/Events/End/${event.id}?teamId=${teamId}`
      );

      getEvents();
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#EAEAEA] p-4 rounded-lg mb-2">
      <p className="text-[#667084] text-lg font-semibold">{event.title}</p>
      <p className="text-[#667084] text-xs my-2 mb-4">{""}</p>
      <div className="flex items-center gap-2">
        <CButton
          loading={checking}
          action={async () => {
            // if (presentation.isEvent) {
            //   // get the event id and then decide on where it should go
            //   try {
            //     setChecking(true);
            //     const result = await instance.get(
            //       `/Events/${presentation.eventId}`,
            //     );
            //     const eventsData: EventsInterface = result.data;
            //     if (
            //       eventsData.status === 1 &&
            //       eventsData.currentPresentation === presentation.id
            //     ) {
            //       navigate(
            //         `/active-presentation/${presentation.id}/${eventsData.id}?isEvent=true`,
            //       );
            //     } else {
            //       navigate(`/active-presentation/${presentation.id}`);
            //     }
            //   } catch (e) {
            //   } finally {
            //     setChecking(false);
            //   }
            // } else {
            //   navigate(`/active-presentation/${presentation.id}`);
            // }

            if (event.role === "EventOwner") {
              navigate(
                `/active-event/${event.id}/${event.teamId}?isEvent=${true}`
              );
            } else {
              navigate(`/join/${event.friendlyId}`);
            }
          }}
          iconPosition={"left"}
          icon={eyeWhite}
          text={event.role === "EventOwner" ? "Continue" : "Join"}
          variant={"dark"}
        />
        {event.role === "EventOwner" && (
          <CButton
            loading={loading}
            action={() => endOnGoingEvent()}
            iconPosition={"left"}
            icon={closeIcon}
            text={"Close"}
            variant={"primaryGrey"}
          />
        )}
      </div>
    </div>
  );
};
